<template>
  <div id="product">
    <Header />
    <Main />

    <v-card elevation="2" :class="['mx-5 my-5']" :loading="loading ? fullConfig.theme.colors.mlt.brown : false" loader-height="4">

      <div class="lg:grid lg:grid-flow-row lg:gap-0 lg:grid-cols-8 xl:grid-cols-12">
        <template v-if="getProductProperties === undefined">
          <v-row>
            <v-col>
              <p class="m-5">That is not a valid link.</p>
            </v-col>
          </v-row>
        </template>

        <Loading v-if="loading" />

        <template v-else>
          <div id="gallery" class="md:col-span-5 lg:col-span-4 flex flex-col content-start xl:w-full">
            <v-img
              v-if="typeof getProductProperties.images == 'object' && getProductProperties.images[0] != ''"
              :src="`${getProductProperties.images[selectedImageIndex].src}`"
              :alt="getProductProperties.name"
              :title="getProductProperties.name"
              contain
            >
            </v-img>

            <template v-if="typeof getProductProperties.images == 'object'">
              <div class="grid grid-flow-col w-full self-center xl:gap-0 xl:self-start">
                <template v-for="(image, i) in getProductProperties.images">
                  <picture
                    v-if="i != 'main'"
                    :key="i"
                    :class="['block m-3 border rounded-lg overflow-hidden cursor-pointer', i==1 ? 'xl:my-3' : 'xl:mb-3']"
                    @click="selectedImageIndex = i"
                    :alt="getProductProperties.name"
                  >
                    <img
                      :src="`${image.src}`"
                      :alt="getProductProperties.name"
                      :title="getProductProperties.name"
                      class=""
                    />
                  </picture>
                </template>
              </div>
            </template>
          </div>

          <div id="details" class="col-span-3 lg:col-span-4 xl:col-span-8">
            <v-card-title class="">
              {{ getProductProperties.name }}
            </v-card-title>

            <!-- SKU -->
            <v-card-text class="flex flex-row flex-wrap gap-4">
              <div class="inline-block border border-solid border-mlt-lightergrey rounded-md">
                <p class="text-xs bg-gray-600 p-2 text-white text-center">SKU</p>
                <p class="p-2">
                  {{ getProductProperties.sku }}
                </p>
              </div>

            <!-- Stock -->
              <div class="inline-block border border-solid border-green-500 rounded-md">
                <p
                  :class="[
                    'text-xs p-2 text-white text-center',
                    getProductProperties.stock_status != 'instock' ? 'bg-orange-500' : 'bg-green-500'
                  ]"
                >Stock</p>
                <p class="p-2">
                  {{ getProductProperties.stock_status != 'instock' ? 'Out of stock' : 'In stock' }}
                </p>
              </div>
            </v-card-text>

            <!-- Action -->
            <v-card-text v-if="getProductProperties.url != '' || getProductProperties.url == '#'" class="place-self-center">
              <div class="inline-block w-full xl:w-auto border border-solid border-yellow-500 rounded-md">
                <p class="text-xs bg-yellow-500 p-2 text-black text-center font-extrabold uppercase">Buy from</p>
                <div class="flex flex-col xl:flex-row flex-no-wrap content-center">
                  <v-btn
                    x-large
                    elevation="0"
                    tile
                    :color="fullConfig.theme.colors.mlt.yellow"
                    :href="getProductProperties.permalink"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-center bg-yellow-500"
                  >
                    <v-icon left>
                      mdi-checkbox-marked-circle
                    </v-icon>
                    MilanoLeather.ae
                  </v-btn>
                  <v-divider></v-divider>
                  <v-btn
                    v-if="getProductAmazonUrl"
                    x-large
                    elevation="0"
                    color="#fff"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    :to="`//${getProductAmazonUrl.value}`"
                  >
                    <IconAmazon/>
                  </v-btn>
                  <v-divider></v-divider>
                  <v-btn
                    v-if="getProductNoonUrl"
                    x-large
                    elevation="0"
                    color="#fff"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    :to="`//${getProductNoonUrl.value}`"
                  >
                    <IconNoon/>
                  </v-btn>
                </div>
              </div>
            </v-card-text>

            <!-- Colours -->
            <div v-if="typeof getProductProperties.colours == 'object' && Object.keys(getProductProperties.colours).length > 0" class="">
              <v-card-text class="label">
                Colours
                <!-- <p v-if="$route.params.colour !== undefined">{{ $route.params.colour }}</p> -->
                <v-chip-group column>
                  <v-chip v-for="(colour, colourCode) in getProductProperties.colours" :key="colourCode" class="text-center" :color="colour" text-color="white" @click.prevent="selectVariant({ url: getProductProperties.url, colourCode })">
                    <v-avatar v-if="$route.params.colour != 'undefined' && $route.params.colour == colourCode" class="mr-1">
                      <v-icon>mdi-checkbox-marked-circle</v-icon>
                    </v-avatar>
                    {{ colour }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </div>

            <!-- Sizes -->
            <div v-if="typeof getProductProperties.sizes == 'object' && Object.keys(getProductProperties.sizes).length > 0" class="">
              <v-card-text class="label">
                Sizes
                <v-chip-group column>
                  <v-chip v-for="(size, sizeCode) in getProductProperties.sizes" :key="sizeCode" class="text-center" v-text="size"></v-chip>
                </v-chip-group>
              </v-card-text>
            </div>

            <!-- Description -->
            <v-card-text>
              <section class="border border-solid border-mlt-lightergrey rounded">
                <h3 class="p-2 text-xs text-center bg-mlt-lightergrey text-white">Description</h3>
                <article class="desc p-4" v-html="getProductProperties.description"></article>
              </section>
            </v-card-text>
          </div>
        </template>
      </div>
    </v-card>

    <Footer />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import Header from '@/components/Header.vue';
import Main from "@/components/body/Main.vue";
import Footer from '@/components/Footer.vue';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';

// Icons
import IconNoon from '@/components/product/IconNoon.vue';
import IconAmazon from '@/components/product/IconAmazon.vue';

export default {
  name: "Product",

  components: {
    Loading,
    Header,
    Main,
    Footer,
    IconNoon,
    IconAmazon,
  },

  mounted() {
    this.SET_PRODUCT_LOADING(true);
    this.findProduct({
      sku: this.$route.params.sku,
    });
  },

  computed: {
    ...mapState({
      loading: state => state.pages.product.loading,
      fullConfig: state => state.fullConfig,
    }),
    ...mapGetters({
      getProductProperties: 'getProductProperties',
      getProductAmazonUrl: 'getProductAmazonUrl',
      getProductNoonUrl: 'getProductNoonUrl',
      getActiveProductProperties: 'getActiveProductProperties',
    }),
  },

  data() {
    return {
      selectedImageIndex: 0,
    }
  },

  methods: {
    ...mapActions({
      findProduct: 'findProduct',
      setVariant: 'setVariant',
    }),
    ...mapMutations({
      SET_PRODUCT_LOADING: "SET_PRODUCT_LOADING",
    }),
    selectVariant: function(payload) {
      this.setVariant(payload);
      if (this.$route.params.colour != payload.colourCode) {
        this.$router.push(`${payload.url}/${payload.colourCode}`);
      }
    },
  },
}
</script>

<style lang="scss">
.label {
  font-size: 0.75rem;
}
.v-card .col-3 img {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: 1px solid;
}
</style>
